module.exports = __webpack_public_path__ + "index_pc/media/under_tip_02.2e540911.mp3";